import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.quotes.views.FreehandLineItemView.';
  public static readonly freehand = `${Id.prefix}freehand`;
  public static readonly quantityGreaterThanZero = `${Id.prefix}quantityGreaterThanZero`;
  public static readonly isTaxableItem = `${Id.prefix}isTaxableItem`;
  public static readonly title = `${Id.prefix}title`;
  public static readonly description = `${Id.prefix}description`;
  public static readonly quantity = `${Id.prefix}quantity`;
  public static readonly unitCost = `${Id.prefix}unitCost`;
  public static readonly totalCost = `${Id.prefix}totalCost`;
  public static readonly notes = `${Id.prefix}notes`;
  public static readonly newFreehand = `${Id.prefix}newFreehand`;
}

export class LangFreehandLineItemView {
  private constructor() {}
  public static freehand(): string {
    return interpolate(Id.freehand);
  }
  public static quantityGreaterThanZero(): string {
    return interpolate(Id.quantityGreaterThanZero);
  }
  public static isTaxableItem(): string {
    return interpolate(Id.isTaxableItem);
  }
  public static title(): string {
    return interpolate(Id.title);
  }
  public static description(): string {
    return interpolate(Id.description);
  }
  public static quantity(): string {
    return interpolate(Id.quantity);
  }
  public static unitCost(): string {
    return interpolate(Id.unitCost);
  }
  public static totalCost(): string {
    return interpolate(Id.totalCost);
  }
  public static notes(): string {
    return interpolate(Id.notes);
  }
  public static newFreehand(): string {
    return interpolate(Id.newFreehand);
  }
}

export class FreehandLineItemViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.freehand, "{{glossary 'freehand'}}", 'Glossary term for freehand');
    register.add(
      Id.quantityGreaterThanZero,
      'Please provide a quantity greater than 0',
      'Validation message for quantity'
    );
    register.add(Id.isTaxableItem, 'Is Taxable Item', 'Label for taxable item switch');
    register.add(Id.title, 'Title', 'Label for title field');
    register.add(Id.description, 'Description', 'Label for description field');
    register.add(Id.quantity, 'Quantity', 'Label for quantity field');
    register.add(Id.unitCost, 'Unit Cost', 'Label for unit cost field');
    register.add(Id.totalCost, 'Total Cost', 'Label for total cost field');
    register.add(Id.notes, 'Notes', 'Label for notes field');
    register.add(Id.newFreehand, "New {{glossary 'freehand'}}", 'Default title for new freehand item');
  }
}
